
<!--  https://www.tiny.cloud/docs/integrations/vue/ -->
<Editor
  ref="ref_tiny"
  v-bind="$attrs"
  v-on="$listeners"
  api-key="62h30acwjeatliy6e320kzwvvvrylw9x82ack3cxnvqfnnfo"
  :init="myInit"
/>
